const config = {
    // http: 'http://local-api.kyhc.top/',          // 本地环境服务
    http: 'https://api.yuyooke.com/',          // 测试环境服务
    // http: 'https://api.kyhc.top/',               // 正式环境服务

    storageComponent: true,                         // 是否本地存储component
    storagePath: true                               // 是否本地存储路由路径
}

export default config